export { CheckoutLegalTerms } from './CheckoutLegalTerms'
